import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/seonav")({
  component: SeonavSectionLayout,
});

function SeonavSectionLayout() {
  return <Outlet />;
}
